module.exports = __webpack_public_path__ + "img/Settlement.bffb359a.png";